import { WindowEnvironmentKind } from '@/src/client/models/WindowEnvironmentKind';

export class Environment {
    static isBrowser(): boolean {
        return typeof window !== 'undefined';
    }

    static isServiceWorker(): boolean {
        return Environment.getEnvironmentKind() === WindowEnvironmentKind.ServiceWorker;
    }

    static getEnvironmentKind(): WindowEnvironmentKind {
        if (typeof window === 'undefined') {
            if (typeof (self as unknown as ServiceWorkerGlobalScope)?.registration !== 'undefined') {
                return WindowEnvironmentKind.ServiceWorker;
            }

            return WindowEnvironmentKind.Unknown;
        }

        return WindowEnvironmentKind.Host;
    }

    static supportsServiceWorkers(): boolean {
        return Environment.isServiceWorker() || (typeof navigator !== 'undefined' && 'serviceWorker' in navigator);
    }

    static supportsPushManager(): boolean {
        if (Environment.isServiceWorker()) {
            return true;
        }

        return Environment.isBrowser() && 'PushManager' in window;
    }
}
